import { createContext } from 'react';

import type { IPerson, IToken, IUserProfile } from '../utils/types';

export interface IAuthContext {
  token?: IToken;
  isAuthInitializing: boolean;
  user?: IUserProfile;
  actor?: IPerson;
  setUserToken(token: IToken): void;
  logout(): void;
}

export const AuthContext = createContext<IAuthContext>({
  isAuthInitializing: false,
  setUserToken: () => {},
  logout: () => {},
});
AuthContext.displayName = 'AuthContext';
